import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CurrencyDropdownComponent } from './components/currency-dropdown/currency-dropdown.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    MatChipsModule,
    MatMenuModule,
    MatIconModule
  ],
  declarations: [CurrencyDropdownComponent],
  exports: [CurrencyDropdownComponent],
})
export class CurrencyDropdownModule { }
